<template>
  <div class="option-wrapper">
    <div style="padding: 0 0 3px 10px">2. 图形选项设置:</div>
    <div class="option-setting">
      <keep-alive>
        <component :is="activeType" ref="chartSetting"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: "option-setting",
  props: ["type"],
  watch: {
    type: {
      handler(newval) {
        if(newval) {
            this.activeType = this[newval] ? this[newval] : null
        }
      },
    },
  },
  data() {
    return {
      activeType: null,
      linechart: () => import("../optionComps/linechart"),
      histogram: () => import("../optionComps/histogram"),
      piechart: () => import("../optionComps/piechart"),
      website: () => import("../optionComps/website"),
    };
  },
  methods: {
    getOptionSetting() {
      return this.$refs.chartSetting.getOption();
    }
  }
};
</script>

<style lang="scss" scoped>
.option-wrapper {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .option-setting {
    width: 100%;
    max-height: 290px;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
    scrollbar-color: #00a4ff transparent;
    scrollbar-width: thin;

    ::-webkit-scrollbar {
      width: 3px;
    }

    ::-webkit-scrollbar-thumb {
      background: #00a4ff;
      border-radius: 10px;
    }
  }
}
</style>
